import type { UserQuestDetail } from "Infrastructure/Api/Api";
import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { CustomCard } from "./CustomCard";

export const RequestList: FC<{
  requests: UserQuestDetail[];
  emptyMessage: string;
  onRequestClick: (request: UserQuestDetail) => void;
}> = ({ requests, emptyMessage, onRequestClick }) => {
  const { colors } = useTheme();

  if (requests.length === 0) {
    return (
      <Typography color={colors.text.secondary}>{emptyMessage}</Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {requests.map((request) => (
        <CustomCard
          key={request.userQuestID}
          request={request}
          onClick={() => onRequestClick(request)}
        />
      ))}
    </Stack>
  );
};
